package com.catbit.opinionpoll.core.strings

import kotlinx.browser.window

fun getSystemLocale(): String = window.navigator.language